<template>
	<div class="meta-label-with-action">
		<span class="meta-label">Participantes</span>
		<v-menu offset-y :close-on-content-click="false" min-width="360" max-width="420">
			<template v-slot:activator="{ on, attrs }">
				<button class="icon-action-btn ml-2" v-bind="attrs" v-on="on">
					<v-icon size="14" color="#2D4B95">mdi-eye</v-icon>
				</button>
			</template>
			<v-list dense class="py-0 responsible-menu">
				<v-list-item dense style="min-height:32px; background:#2D4B95;">
					<div class="d-flex justify-space-between align-center" style="width:100%">
						<p class="caption mb-0 white--text font-weight-bold">Participantes</p>
						<v-btn icon dark x-small @click="$emit('openAddParticipant')">
							<v-icon dark size="16">mdi-plus-circle</v-icon>
						</v-btn>
					</div>
				</v-list-item>

				<!-- Sin participantes activos -->
				<div
					class="pa-3 text-center"
				v-if="activeParticipants.length === 0 && futureParticipants.length === 0 && historicParticipants.length === 0"
			>
				<v-icon color="#ccc" size="24">mdi-account-off-outline</v-icon>
				<p class="caption mb-0 mt-1" style="color:#999">Sin participantes</p>
			</div>

			<!-- Participantes activos -->
			<v-list-item-group class="overflow-y-auto" style="max-height:300px">
				<v-list-item
					v-for="(p, i) in activeParticipants"
					:key="'a-' + i"
					class="px-0 py-0"
				>
						<div style="width:100%">
							<div class="participant-row">
								<div class="participant-row-left" style="width:100%">
									<img
										v-if="p.participant.info && p.participant.info.avatar"
										:src="p.participant.info.avatar"
										class="participant-avatar"
									/>
									<v-icon v-else size="36" color="#ccc">mdi-account-circle</v-icon>
									<div class="participant-info" style="width: 100%;">
										<div class="d-flex align-center justify-space-between" style="gap: 4px;">
											<div>
												<p class="mb-0 caption font-weight-bold" style="color:#333">{{ p.participant.name }}</p>
												<p class="mb-0 caption" style="color:#777">{{ p.participant.email }}</p>
											</div>
											<button
												class="icon-action-btn danger"
												:disabled="loading"
												@click="$emit('removeParticipant', p)"
											>
												<v-icon size="14" color="#991B1B">mdi-delete-outline</v-icon>
											</button>
										</div>
										<div class="d-flex">
											<div v-if="p.start_date" class="limit-date-row">
												<v-icon size="11" color="#2D4B95">mdi-calendar-clock-outline</v-icon>
												<span class="participant-limit-date">Desde {{ p.start_date | toDate }}</span>
											</div>
											<v-divider v-if="p.start_date && p.limit_date" inset vertical class="mx-2" />
											<div v-if="p.limit_date" class="limit-date-row">
												<v-icon size="11" color="#2D4B95">mdi-calendar-clock-outline</v-icon>
												<span class="participant-limit-date">Hasta {{ p.limit_date | toDate }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<v-divider />
						</div>
					</v-list-item>
				</v-list-item-group>

				<!-- Participantes futuros -->
				<template v-if="futureParticipants.length > 0">
					<div
						class="future-header"
						@click="showFuture = !showFuture"
					>
						<div class="d-flex align-center" style="gap:6px">
						<v-icon size="13" color="#4B5E9E">mdi-calendar-check-outline</v-icon>
						<span>Próximos ({{ futureParticipants.length }})</span>
					</div>
					<v-icon size="14" color="#4B5E9E">{{ showFuture ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
				</div>

				<v-list-item-group v-if="showFuture" class="overflow-y-auto" style="max-height:200px">
					<v-list-item
						v-for="(p, i) in futureParticipants"
						:key="'f-' + i"
						class="px-0 py-0"
					>
						<div style="width:100%">
							<div class="participant-row future">
								<div class="participant-row-left">
									<img
										v-if="p.participant.info && p.participant.info.avatar"
										:src="p.participant.info.avatar"
										class="participant-avatar future-avatar"
									/>
									<v-icon v-else size="36" color="#9CA3AF">mdi-account-circle</v-icon>
									<div class="participant-info">
										<p class="mb-0 caption font-weight-bold" style="color:#4B5E9E">{{ p.participant.name }}</p>
										<p class="mb-0 caption" style="color:#6B7280">{{ p.participant.email }}</p>
										<div class="limit-date-row">
											<v-icon size="11" color="#4B5E9E">mdi-calendar-clock-outline</v-icon>
											<span class="participant-limit-date" style="color:#4B5E9E">Desde {{ p.start_date | toDate }}</span>
										</div>
									</div>
								</div>
							</div>
							<v-divider />
						</div>
					</v-list-item>
				</v-list-item-group>
			</template>

		<!-- Histórico de participantes -->
		<template v-if="historicParticipants.length > 0">
			<div
				class="historic-header"
				@click="showHistoric = !showHistoric"
			>
				<div class="d-flex align-center" style="gap:6px">
					<v-icon size="13" color="#9CA3AF">mdi-history</v-icon>
					<span>Histórico ({{ historicParticipants.length }})</span>
				</div>
				<v-icon size="14" color="#9CA3AF">{{ showHistoric ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
			</div>

			<v-list-item-group v-if="showHistoric" class="overflow-y-auto" style="max-height:200px">
				<v-list-item
					v-for="(p, i) in historicParticipants"
					:key="'h-' + i"
					class="px-0 py-0"
				>
					<div style="width:100%">
						<div class="participant-row historic">
							<div class="participant-row-left">
								<img
									v-if="p.participant.info && p.participant.info.avatar"
									:src="p.participant.info.avatar"
									class="participant-avatar historic-avatar"
								/>
								<v-icon v-else size="36" color="#e0e0e0">mdi-account-circle</v-icon>
								<div class="participant-info">
									<p class="mb-0 caption font-weight-bold" style="color:#9CA3AF">{{ p.participant.name }}</p>
									<p class="mb-0 caption" style="color:#C4C4C4">{{ p.participant.email }}</p>
									<div class="limit-date-row">
										<v-icon size="11" color="#D1D5DB">mdi-account-remove-outline</v-icon>
										<span class="participant-limit-date" style="color:#9CA3AF">Hasta {{ formatLimitDate(p.deleted_at) }}</span>
									</div>
								</div>
							</div>
						</div>
						<v-divider />
					</div>
				</v-list-item>
			</v-list-item-group>
		</template>
			</v-list>
		</v-menu>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	name: 'TaskParticipants',
	props: {
		tarea: {
			type: Object,
			required: true
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	emits: ['openAddParticipant', 'removeParticipant'],
	data: () => ({
		showHistoric: false,
		showFuture: false
	}),
	computed: {
		activeParticipants() {
			if (!this.tarea.participants) return []
			return this.tarea.participants.filter(
				p => !p.deleted_at && this.tarea.responsable != p.user_id
			)
		},
		futureParticipants() {
			if (!this.tarea.participants) return []
			const now = moment()
			return this.tarea.participants.filter(p => {
				if (!p.deleted_at || !p.start_date) return false
				return moment(p.start_date).isAfter(now)
			})
		},
		historicParticipants() {
			if (!this.tarea.participants) return []
			const now = moment()
			return this.tarea.participants.filter(p => {
				if (!p.deleted_at) return false
				// Si tiene start_date en el futuro, no es histórico (es futuro)
				if (p.start_date && moment(p.start_date).isAfter(now)) return false
				return true
			})
		}
	},
	methods: {
		formatLimitDate(date) {
			return moment(date).format('DD/MM/YYYY')
		}
	}
}
</script>

<style scoped>
.meta-label-with-action {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 8px;
	margin-bottom: 8px;
}

.meta-label {
	font-size: 11px;
	font-weight: 600;
	color: #6B7280;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	margin: 0;
}


.icon-action-btn {
  width: 28px; height: 28px; border-radius: 7px;
  background: #EEF2FF; border: none; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center;
  transition: background 0.12s;
}
.icon-action-btn:hover { background: #dde5f9; }
.icon-action-btn.success { background: #DCFCE7; }
.icon-action-btn.success:hover { background: #BBF7D0; }
.icon-action-btn.danger  { background: #FEE2E2; }
.icon-action-btn.danger:hover  { background: #FECACA; }
.participant-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px;
	gap: 12px;
}
.participant-row-left {
	display: flex;
	align-items: center;
	gap: 12px;
	min-width: 0;
}
.participant-avatar {
	width: 38px;
	height: 38px;
	border-radius: 50%;
	object-fit: cover;
	flex-shrink: 0;
}
.participant-info {
	display: flex;
	flex-direction: column;
	min-width: 0;
}
.limit-date-row {
	display: flex;
	align-items: center;
	gap: 4px;
	margin-top: 3px;
}
.participant-limit-date {
	font-size: 11px;
	color: #2D4B95;
	font-weight: 500;
}
.historic-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 6px 14px;
	background: #F9FAFB;
	border-top: 1px solid #E5E7EB;
	cursor: pointer;
	font-size: 11px;
	font-weight: 600;
	color: #9CA3AF;
	text-transform: uppercase;
	letter-spacing: 0.4px;
	user-select: none;
}
.historic-header:hover {
	background: #F3F4F6;
}
.participant-row.historic {
	opacity: 0.75;
}
.participant-avatar.historic-avatar {
	filter: grayscale(60%);
}
.future-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 6px 14px;
	background: #F0F4FF;
	border-top: 1px solid #D5E3F9;
	cursor: pointer;
	font-size: 11px;
	font-weight: 600;
	color: #4B5E9E;
	text-transform: uppercase;
	letter-spacing: 0.4px;
	user-select: none;
}
.future-header:hover {
	background: #E8F1FF;
}
.participant-row.future {
	background: #F8FAFF;
}
.participant-avatar.future-avatar {
	filter: none;
}
</style>
